import LoadingSpinner from './LoadingSpinner.jsx';

const variants = {
  primary:
    'bg-slate-800 text-white hover:bg-slate-700 focus-visible:ring-slate-600 disabled:bg-slate-300',
  ghost:
    'bg-transparent text-slate-700 border border-slate-300 hover:bg-slate-100 focus-visible:ring-slate-400',
  danger:
    'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500 disabled:bg-red-300',
};

export default function Button({
  variant = 'primary',
  children,
  loading = false,
  className = '',
  ...props
}) {
  return (
    <button
      className={`
        inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium
        transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
        disabled:cursor-not-allowed
        ${variants[variant] ?? variants.primary}
        ${className}
      `}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && <LoadingSpinner size="sm" />}
      {children}
    </button>
  );
}
